module.exports = __webpack_public_path__ + "img/RVO_Logo.179ae298.png";